// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fe94e9 {
  position: relative;
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.f8f91e::before {
  content: "•";
  left: 0;
  width: 24px;
  display: block;
}
.f8f91e {
  display: flex;
}
.f02838 {
  line-height: 1.2307692308;
  font-size: 0.8125rem;
  font-family: "HM Sans Regular", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", Osaka, "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
  font-weight: 400;
  text-transform: none;
}
.ce22ce {
  line-height: 1.45;
  font-size: 0.688rem;
  font-family: "HM Sans Regular", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", Osaka, "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
  font-weight: 400;
  text-transform: none;
}
.f02d13 {
  line-height: 1.25;
  font-size: 1rem;
  font-family: "HM Sans Regular", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", Osaka, "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
  font-weight: 400;
  text-transform: none;
}
.f8f91e:not(:last-child) {
  margin-bottom: 8px;
}`, "",{"version":3,"sources":["webpack://./node_modules/@hm-group/fabric-components/dist/esm/brand/hm/components/Lists/BulletList/BulletList.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;AACA;EACE,YAAY;EACZ,OAAO;EACP,WAAW;EACX,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,wIAAwI;EACxI,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wIAAwI;EACxI,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,wIAAwI;EACxI,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB","sourcesContent":[".fe94e9 {\n  position: relative;\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n.f8f91e::before {\n  content: \"•\";\n  left: 0;\n  width: 24px;\n  display: block;\n}\n.f8f91e {\n  display: flex;\n}\n.f02838 {\n  line-height: 1.2307692308;\n  font-size: 0.8125rem;\n  font-family: \"HM Sans Regular\", \"ヒラギノ角ゴ Pro W3\", \"Hiragino Kaku Gothic Pro\", Osaka, \"メイリオ\", Meiryo, \"ＭＳ Ｐゴシック\", \"MS PGothic\", sans-serif;\n  font-weight: 400;\n  text-transform: none;\n}\n.ce22ce {\n  line-height: 1.45;\n  font-size: 0.688rem;\n  font-family: \"HM Sans Regular\", \"ヒラギノ角ゴ Pro W3\", \"Hiragino Kaku Gothic Pro\", Osaka, \"メイリオ\", Meiryo, \"ＭＳ Ｐゴシック\", \"MS PGothic\", sans-serif;\n  font-weight: 400;\n  text-transform: none;\n}\n.f02d13 {\n  line-height: 1.25;\n  font-size: 1rem;\n  font-family: \"HM Sans Regular\", \"ヒラギノ角ゴ Pro W3\", \"Hiragino Kaku Gothic Pro\", Osaka, \"メイリオ\", Meiryo, \"ＭＳ Ｐゴシック\", \"MS PGothic\", sans-serif;\n  font-weight: 400;\n  text-transform: none;\n}\n.f8f91e:not(:last-child) {\n  margin-bottom: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
